import React from 'react';
import { Card, CardContent, Typography, Chip, Box, Button } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

const BRAND_BLUE = '#14a9e8';
const BRAND_INK = '#0b1620';

const SERVICE_AREAS = [
  'Eugene',
  'Springfield',
  'Santa Clara',
  'River Road',
  'Bethel',
  'Thurston',
];

const EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d90000!2d-123.09!3d44.05!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4t5!5e0!3m2!1sen!2sus';

const ServiceAreaMap = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <Card
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <LocationOnIcon sx={{ color: BRAND_BLUE, fontSize: 28 }} />
          <Typography
            variant="h5"
            component="h2"
            sx={{ fontWeight: 700, color: 'text.primary' }}
          >
            Our Service Area
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{ color: 'text.secondary', mb: 3 }}
        >
          Proudly serving Eugene, Springfield, and surrounding communities in
          Lane County, Oregon.
        </Typography>

        <Box
          ref={ref}
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            mb: 3,
            border: '1px solid',
            borderColor: 'divider',
            minHeight: 400,
            bgcolor: 'action.hover',
          }}
        >
          {inView && (
            <iframe
              src={EMBED_URL}
              width="100%"
              height="400"
              style={{ display: 'block', border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Service area map showing Eugene and Springfield, Oregon"
            />
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: 3,
            justifyContent: 'center',
          }}
        >
          {SERVICE_AREAS.map((area) => (
            <Chip
              key={area}
              icon={<LocationOnIcon />}
              label={area}
              sx={{
                backgroundColor: `${BRAND_BLUE}15`,
                color: 'text.primary',
                fontWeight: 600,
                '& .MuiChip-icon': {
                  color: BRAND_BLUE,
                },
              }}
            />
          ))}
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', mb: 1.5 }}
          >
            Not sure if we serve your area? Ask us!
          </Typography>
          <Button
            component={Link}
            to="/quote"
            variant="contained"
            sx={{
              backgroundColor: BRAND_BLUE,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              px: 4,
              '&:hover': {
                backgroundColor: '#1191c8',
              },
            }}
          >
            Get a Free Quote
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceAreaMap;
